@let apiResponse = data.value(); @if (apiResponse) {
<p-select
  [options]="apiResponse"
  optionLabel="navn"
  optionValue="id"
  placeholder="Vælg pengeinstitut"
  [disabled]="isDisabled"
  [ngModel]="valueSignal()"
  (ngModelChange)="onValueChange($event)"
  appendTo="body"
/>
}
